import React from 'react';
import { FactFindForm } from '@/components/forms/FactFindForm';

export const QuotesTab = () => {
	return (
		<>
			<FactFindForm title={'Quote'} factFindType={'quote'} />
		</>
	);
};
